<template>
	<div class="sessions">
		<div v-if="!items">
			<a-tag>Неизвестно</a-tag>
		</div>

		<div v-else-if="normalizedItems.length" class="sessions__items">
			<div v-for="item of normalizedItems" :key="item.id" class="sessions__session session">
				<div class="session__id">
					<Tooltip placement="top">
						<template #title>ID сессии</template>
						<Tag color="blue">{{ item.id }}</Tag>
					</Tooltip>
				</div>

				<div class="session__last-activity">
					<Tooltip placement="top">
						<template #title>Время последней активности</template>
						<Tag color="blue">{{ item.lastActivity }}</Tag>
					</Tooltip>
				</div>

				<div class="session__lifetime">
					<Tooltip placement="top">
						<template #title>Осталось жить</template>
						<Tag color="blue">{{ item.lifetime }}</Tag>
					</Tooltip>
				</div>
			</div>
		</div>

		<Tag v-else color="orange">Нет открытых сессий</Tag>
	</div>
</template>

<script>
import moment from "moment"
import { Tag, Tooltip } from "ant-design-vue"

export default {
	name: "UserTableSessions",
	components: {
		Tag,
		Tooltip
	},
	props: {
		items: { type: Array, required: true }
	},
	computed: {
		normalizedItems() {
			return this.items.map(item => {
				const lastActivity = moment.unix(item.last_activity).format("DD.MM.YYYY HH:mm")
				const lifetime = moment.unix(item.last_activity + item.lifetime).fromNow(true)

				return { ...item, lastActivity, lifetime }
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.session {
	display: flex;
	padding: 10px 0;
	border-bottom: 1px solid #ddd;

	&:last-child {
		border-bottom: none;
	}

	&__label {
		font-weight: bold;
	}
	&__id {
		font-weight: bold;
	}
	&__last-activity {
		margin-left: 20px;
	}
	&__lifetime {
		margin-left: 20px;
	}
}
</style>
